export default __webpack_public_path__ + "static/media/alex-expedibox.7d28ac8b.jpg";